import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store";
import Home from '../pages/home/home.vue'
import Exhibit from '../pages/exhibit/exhibit.vue'
import Zpxq from '../pages/zpxq/zpxq.vue'
import Exhibitor from '../pages/exhibitor/exhibitor.vue'
import Zsxq from '../pages/zsxq/zsxq.vue'
import Supply from '../pages/supply/supply.vue'

import AddSupply from '../pages/addSupply/addSupply.vue'
import Sjxq from '../pages/sjxq/sjxq.vue'
import Live from '../pages/live/live.vue'

import Planning from "../pages/planning/planning.vue"
import Activities from "../pages/activities/activities.vue"
import Ccpit from "../pages/ccpit/ccpit.vue"
import Seminar from "../pages/seminar/seminar.vue"
import NewList from "../pages/newsList/newList.vue"
import Registered from "../pages/registered/registered.vue";
import RetrievePass from "../pages/retrievePass/retrievePass.vue";
import Login from "../pages/login/login.vue";

import User from "../pages/user/user.vue"
import MerchantsCollection from "../pages/userchildren/merchantsCollection/merchantsCollection.vue";
import GoodsCollection from "../pages/userchildren/goodsCollection/goodsCollection.vue";
import IntentionOrder from "../pages/userchildren/intentionOrder/intentionOrder.vue";
import AboutGoods from "../pages/userchildren/aboutGoods/aboutGoods.vue";
import AboutAudience from "../pages/userchildren/aboutAudience/aboutAudience.vue";
import PurchaseManagement from "../pages/userchildren/purchaseManagement/purchaseManagement.vue";
import SupplyManagement from "../pages/userchildren/supplyManagement/supplyManagement.vue";
import Comments from "../pages/userchildren/comments/comments.vue";
import Consulting from "../pages/userchildren/consulting/consulting.vue";
import Achat from "../pages/userchildren/aChat/aChat.vue";
import Modified from "../pages/userchildren/modifiedData/modifiedData.vue";

// import Credential from "../pages/credential/credential.vue"

Vue.use(VueRouter)
const Router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  routes:[
    {//展品
      path:'/exhibit/',
      component:Exhibit,
    },
    {//展品详情
      path:'/exhibit/details/:id/:ocid',
      component:Zpxq,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (isMobile()=='app') {
          if (islogin*1 === 0) 
            next({path:'/login'})
        }else{
          if (islogin*1 === 0) {
            next({path:'/home'})
            store.dispatch("dialog",true)
          }
        }
        next()
      },
    },
    {//展商
      path:'/exhibitor/',
      component:Exhibitor,
    },
    {//展商详情
      path:'/exhibitor/details/:id/:ocid',
      component:Zsxq,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (isMobile()=='app') {
          if (islogin*1 === 0) 
            next({path:'/login'})
        }else{
          if (islogin*1 === 0) {
            next({path:'/home'})
            store.dispatch("dialog",true)
          }
        }
        next()
      },
    },
    {//直播
      path:'/live/',
      component:Live,
    },
    {//供需
      path:'/supply',
      component:Supply,
    },
    {//供需发布
      path:'/supply/add/:id',
      component:AddSupply,
    },
    {//供需（商机）详情
      path:'/supply/details/:id',
      component:Sjxq,
    },
    {//注册
      path:'/registered/:id',
      component:Registered,
    },
    {//找回密码
      path:'/retrievePass',
      component:RetrievePass,
    },
    {//登录
      path:'/login',
      component:Login,
    },
    {//首页
      path:'/',
      component:Home,
    },
    {//首页
      path:'/home',
      component:Home,
    },
    {//我的
      path:'/user',
      component:User,
      beforeEnter:(to,from,next)=>{
        console.log(from);
        let islogin = localStorage.getItem('islogin')
        if (isMobile()=='app') {
          console.log(111);
          if (islogin*1 === 0) {
            next({path:'/login'})
          }
        }else{
          if (islogin*1 === 0) {
            next({path:'/home'})
            store.dispatch("dialog",true)
          }
        }
        next()
      },
      children:[
        {//我的-意向订单
          path:'intentionOrder',
          component:IntentionOrder
        },
        {//我的-展商收藏
          path:'merchantsCollection',
          component:MerchantsCollection
        },
        {//我的-展品收藏
          path:'goodsCollection',
          component:GoodsCollection
        },
        
        {//我的-已约展商
          path:'aboutGoods',
          component:AboutGoods
        },
        {//我的-观众邀约
          path:'aboutAudience',
          component:AboutAudience
        },
        {//我的-采购管理
          path:'purchaseManagement',
          component:PurchaseManagement
        },
        {//我的-供应管理
          path:'supplyManagement',
          component:SupplyManagement
        },
        {//我的-我的评论
          path:'comments',
          component:Comments
        },
        {//我的-询盘咨询
          path:'consulting',
          component:Consulting
        },
      ]
    },
    // app ↓
    {//展馆规划
      path:'/home/planning',
      component:Planning
    },
    {//同期活动
      path:'/home/activities',
      component:Activities
    },
    {//同期活动/对接会
      path:'/home/activities/ccpit',
      component:Ccpit
    },
    {//同期活动/对接会
      path:'/home/activities/seminar',
      component:Seminar
    },
    {//同期新闻
      path:'/home/newList',
      component:NewList
    },
    {//我的-展商收藏app
      path:'/userapp/merchantsCollection',
      component:MerchantsCollection,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-展品收藏
      path:'/userapp/goodsCollection',
      component:GoodsCollection,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-意向订单
      path:'/userapp/intentionOrder',
      component:IntentionOrder,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-已约展商
      path:'/userapp/aboutGoods',
      component:AboutGoods,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-观众邀约
      path:'/userapp/aboutAudience',
      component:AboutAudience,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-采购管理
      path:'/userapp/purchaseManagement',
      component:PurchaseManagement,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-供应管理
      path:'/userapp/supplyManagement',
      component:SupplyManagement,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-我的评论
      path:'/userapp/comments',
      component:Comments,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-询盘咨询
      path:'/userapp/consulting',
      component:Consulting,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-询盘咨询-聊天框
      path:'/userapp/consulting/achat/:sendid/:putid/:pid',
      component:Achat,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    {//我的-修改资料
      path:'/userapp/modified/:id',
      component:Modified,
      beforeEnter:(to,from,next)=>{
        let islogin = localStorage.getItem('islogin')
        if (islogin*1 === 0) {
          next({path:'/login'})
        }
        next()
      },
    },
    //// app ↑
    {
      path:'/ceshi',
      component:IntentionOrder,
    },
    {
      path:'*',
      redirect:'/'
    }
  ],
  scrollBehavior () {
    return {x:0,y:0}
  }
})
function isMobile(){
  let facility = ""
  if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    facility="app"
    // this.$router.replace('/m_index');
  } else {
    facility="pc"
    // this.$router.replace('/pc_index');
  }
  return facility
}
export default Router